import { Icon as Iconify } from '@iconify/react';
import { Button, Typography } from '@mui/material';

import { caloTheme } from '../../assets/themes/calo';
import Icon from '../Icon/Icon';

interface NotificationSidebarProps {
  requestNumber: number;
  requestLabel: 'customer' | 'cx' | 'alert';
}

const NotificationSidebar = ({ requestNumber, requestLabel }: NotificationSidebarProps) => {
  const notificationIcon =
    requestLabel === 'alert' ? 'notificationAlert' : requestLabel === 'customer' ? 'notificationCustomer' : 'notificationCX';
  const backgroundColor =
    requestLabel === 'alert'
      ? caloTheme.palette.red
      : requestLabel === 'customer'
        ? caloTheme.palette.secondaryBlue500
        : caloTheme.palette.secondaryPurple500;

  const getIcon = () => {
    if (notificationIcon === 'notificationAlert') {
      return <Iconify icon="lucide:alert-circle" width={16} height={16} style={{ color: 'white' }} />;
    }
    return <Icon name={notificationIcon} width={16} height={16} style={{ minWidth: 16 }} />;
  };

  return (
    <Button
      variant="contained"
      startIcon={getIcon()}
      sx={{
        padding: '6px 4px 6px 4px',
        height: '20px',
        textAlign: 'center',
        maxWidth: '46px',
        minWidth: '30px',
        boxShadow: 'none',
        mx: '2px',
        backgroundColor: backgroundColor,
        '& .MuiButton-startIcon': { ml: 0, mr: '4px' },
        ':hover': {
          boxShadow: 'none',
          backgroundColor: backgroundColor
        }
      }}
    >
      <Typography
        sx={{
          fontSize: '16px',
          fontWeight: 400,
          lineHeight: 1,
          textAlign: 'center',
          color: 'white'
        }}
      >
        {requestNumber}
      </Typography>
    </Button>
  );
};
export default NotificationSidebar;
